import { render, staticRenderFns } from "./TaxaAluguelParametrosDataTable.vue?vue&type=template&id=508da56a&scoped=true"
import script from "./TaxaAluguelParametrosDataTable.vue?vue&type=script&lang=ts"
export * from "./TaxaAluguelParametrosDataTable.vue?vue&type=script&lang=ts"
import style0 from "./TaxaAluguelParametrosDataTable.vue?vue&type=style&index=0&id=508da56a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508da56a",
  null
  
)

export default component.exports